<div class="container mb-3">       
    <div class="row ml-3 mr-3 mt-3 align-items-center">       
        <h5 class="col-3 pr-0 mr-2">Tipo de Transporte:</h5>

        <h5 class="col-3 mb-2 btn btn-lg btn-primary btn-reservar rounded-pill rounded-pill text-left" 
        style="background-color: transparent; color: black;">{{transporteText}}</h5>  
    </div>
    <div *ngIf="tipoTransporte===2" class="row">
        <app-bus-semicama [asientosInic]="passAsientos" [bloqueado]="-1" [asientosSelected]="asientosSelected"></app-bus-semicama>         
    </div>
    <div *ngIf="tipoTransporte===1" class="row">
        <app-coche-mix [asientosInic]="passAsientos" [bloqueado]="-1" [asientosSelected]="asientosSelected"></app-coche-mix>         
    </div>
    <div *ngIf="tipoTransporte===3" class="row">
        <app-minibus [asientosInic]="passAsientos" [bloqueado]="-1" [asientosSelected]="asientosSelected"></app-minibus>         
    </div>

    <div class="text-center z-index--top mt-3">
        <a  class="btn btn-lg btn-primary btn-reservar rounded-pill" (click)="salir()" >Volver</a>
    </div>
</div>
